// extracted by mini-css-extract-plugin
module.exports = {"slickWrapper":"TeamMobile_slickWrapper__9CCB_"};